import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SurfacePage, SoftSurface } from '../components/surface';
import GatheringsManager from '../components/GatheringsManager';
import LoadingSpinner from '../components/LoadingSpinner';
import clubService from '../services/clubService';
import useIsMobile from '../hooks/useIsMobile';

/**
 * /clubs/:id/gatherings — the club's gatherings manager (design_handoff_gatherings §4), for the
 * club's owner and admins. Reached from MANAGE CLUB → FEATURES and the gathering page's host
 * tools. Members and visitors are sent to the club page.
 */
export default function GatheringsManagePage() {
  const { id: clubId } = useParams();
  const navigate = useNavigate();
  const mobile = useIsMobile();
  const [club, setClub] = useState(null);
  const [state, setState] = useState('loading'); // loading | ok | denied

  useEffect(() => {
    let on = true;
    clubService.getClub(clubId).then((r) => {
      if (!on) return;
      const role = r.success ? r.data?.userRole : null;
      if (r.success) setClub(r.data);
      setState(role === 'owner' || role === 'admin' ? 'ok' : 'denied');
    });
    return () => { on = false; };
  }, [clubId]);

  useEffect(() => { if (state === 'denied') navigate(`/clubs/${clubId}`, { replace: true }); }, [state, clubId, navigate]);

  const body = state === 'ok'
    ? <GatheringsManager clubId={clubId} clubName={club?.name} />
    : <div className="flex justify-center py-20"><LoadingSpinner /></div>;

  return (
    <SoftSurface>
      {mobile ? (
        <SurfacePage mobileTitle="GATHERINGS" mobileEyebrow={club?.name ? club.name.toUpperCase() : 'MANAGE CLUB'} onBack={() => navigate(`/clubs/${clubId}/manage`)}>
          <div style={{ paddingBottom: 16 }}>{body}</div>
        </SurfacePage>
      ) : (
        <SurfacePage bare>
          <div className="mx-auto w-full font-mono" style={{ maxWidth: 1080, padding: '24px 32px 72px', boxSizing: 'border-box' }}>{body}</div>
        </SurfacePage>
      )}
    </SoftSurface>
  );
}
